/*
 * @Author: Teemo Ding
 * @Date: 2021-10-21 10:39:42
 * @LastEditTime: 2021-10-21 11:11:11
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Stock/Detail/stockProducts.ts
 */
import { generateErrorKey } from 'src/tools/helper';
import _ from 'lodash';
export const stockProductsCheck = (products) => {
  const _products = _.cloneDeep(products);
  let flag;
  _products.forEach((product) => {
    const { quantity } = product;
    if (!quantity) {
      product[generateErrorKey('quantity')] = true;
      flag = true;
    }
  });

  const isEmpty = _products.length;
  return { data: _products, flag, isEmpty };
};
